import { useUseAnalytics_TrackEventMutation } from '@/graphql/generated';
import { useCallback } from 'react';

export enum AnalyticsEvents {
  PageView = '$pageview',
}

export function useAnalytics() {
  const [trackEventMutation] = useUseAnalytics_TrackEventMutation();

  const trackPage = useCallback(
    async (page: string) => {
      try {
        await trackEventMutation({
          variables: {
            event: AnalyticsEvents.PageView,
            properties: [
              {
                key: 'page',
                value: page,
              },
            ],
          },
        });
      } catch (error) {
        console.error('Failed to track page view:', error);
      }
    },
    [trackEventMutation],
  );

  const trackEvent = useCallback(
    async (event: string, properties: Record<string, string>) => {
      try {
        await trackEventMutation({
          variables: {
            event,
            properties: Object.entries(properties).map(
              ([key, value]: [string, string]) => ({
                key,
                value,
              }),
            ),
          },
        });
      } catch (error) {
        console.error('Failed to track event:', error);
      }
    },
    [trackEventMutation],
  );

  return {
    trackPage,
    trackEvent,
  };
}
